/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc アンケート案内メッセージ
 *
 * @author genka
 * @copyright Copyright 2020 TechMatrix Corporation, Inc. All rights reserved.
 */
<script>
import FcQuestionMessage from './FcQuestionMessage'
import FcMessageUtil from '@/utils/FcMessageUtil'

export default {
  mixins: [FcQuestionMessage],
  name: 'FcSurveyRequestMessage',
  computed: {
    /**
     * messageClass のオーバーライド
     */
    messageClass() {
      return 'fc-survey-request-message ' + 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * answerList のオーバーライド
     */
    answerList() {
      let messageOption = JSON.parse(this.messageInfo.messageOption)
      let answerList = [{
        id: 0,
        label: messageOption.label,
        buttonType: 'primary',
        alwaysEnable: true
      }]
      return answerList
    }
  },
  methods: {

    /**
     * sendAnswerMessage のオーバーライド
     */
    sendAnswerMessage(answerInfo) {
      if (!this.permissionSendAnswerMessage(answerInfo)) {
        return
      }
      this.$emit('openSurvey')
    },

    /**
     * getSendMessageAnswerList のオーバーライド
     */
    getSendMessageAnswerList() {
      return []
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcSurveyRequestMessage.vue